<template>
  <div class="residential-list-status-filter">
    <CheckboxComponent v-model="hideSold" :label="label" class="residential-list-status-filter__hide-sold" />
    <slot />
  </div>
</template>

<script>
import StorageMixin from '@/mixins/Storage'
import { CheckboxComponent } from 'vue-elder-checkbox'

export default {
  mixins: [
    StorageMixin({
      target: 'hideSold',
      key() {
        return `project:dashboard:${this.storageKey}`
      },
      storage: 'localStorage',
    }),
  ],
  props: {
    value: Boolean,
    label: String,
    storageKey: String,
  },
  computed: {
    hideSold: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  components: {
    CheckboxComponent,
  },
}
</script>

<style lang="scss">
.residential-list-status-filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1rem;
  font-size: var(--font-size-small);

  &__hide-sold {
    align-items: center;
    line-height: 1;
  }
}

.elder-dropdown__content-box:has(.residential-list-status-filter__hide-sold) {
  padding: 1rem;
}
</style>
